const STORAGE_KEY = 'neo:postLoginRedirect'

const NON_REPLAYABLE_PREFIXES = ['/login', '/']

export function stashPostLoginRedirect(path: string): void {
  if (NON_REPLAYABLE_PREFIXES.includes(path)) {
    return
  }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path)
  } catch {
    return
  }
}

export function consumePostLoginRedirect(): string | undefined {
  try {
    const stashed = window.sessionStorage.getItem(STORAGE_KEY)
    if (!stashed) {
      return undefined
    }
    window.sessionStorage.removeItem(STORAGE_KEY)
    return stashed
  } catch {
    return undefined
  }
}
